(function () {
  if (window.__cartOrderBumpBound) return;
  window.__cartOrderBumpBound = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // Re-renderiza o conteúdo do cart drawer mantendo-o aberto
  function refreshDrawer(sectionId) {
    return fetch(root + '?sections=' + encodeURIComponent(sectionId))
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var html = data[sectionId];
        if (!html) return;
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.getElementById('CartDrawer-' + sectionId);
        var live = document.getElementById('CartDrawer-' + sectionId);
        if (fresh && live) live.innerHTML = fresh.innerHTML;
      })
      .then(initCarousels);
  }

  // Ativa a bolinha certa conforme o slide visível
  function initCarousels() {
    document.querySelectorAll('[data-ob-track]').forEach(function (track) {
      if (track.__obInit) return;
      track.__obInit = true;
      var wrap = track.closest('[data-order-bump]');
      var dots = wrap ? wrap.querySelectorAll('[data-ob-dot]') : [];
      function update() {
        var w = track.clientWidth || 1;
        var idx = Math.round(track.scrollLeft / w);
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      }
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      update();
    });
  }

  document.addEventListener('click', function (e) {
    // clique na bolinha -> vai pro slide
    var dot = e.target.closest('[data-ob-dot]');
    if (dot) {
      var wrap = dot.closest('[data-order-bump]');
      var track = wrap && wrap.querySelector('[data-ob-track]');
      if (track) {
        var i = Number(dot.getAttribute('data-ob-dot')) || 0;
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      }
      return;
    }

    // "Levar junto!" -> adiciona ao carrinho
    var btn = e.target.closest('[data-order-bump-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('is-loading')) return;
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var drawer = document.querySelector('cart-drawer');
    var sectionId = drawer ? drawer.getAttribute('data-section-id') : null;
    btn.classList.add('is-loading');

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (res) { if (!res.ok) throw new Error('add failed'); return res.json(); })
      .then(function () {
        if (sectionId) return refreshDrawer(sectionId);
        window.location.reload();
      })
      .catch(function (err) { console.error('Order bump:', err); btn.classList.remove('is-loading'); });
  });

  function boot() {
    initCarousels();
    var drawer = document.querySelector('cart-drawer');
    if (drawer && !drawer.__obObserved) {
      drawer.__obObserved = true;
      new MutationObserver(function () { initCarousels(); }).observe(drawer, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();